// Frontend's expected schema version. Compared against
// public.event_state.app_schema_version on every fetch — mismatch surfaces
// as a "Reload required" banner.
//
// Bump in lockstep with a Supabase migration that updates the DB-side value.
// Backward-compatible additions (new columns, new functions, new tables) DO
// NOT require a bump; only changes that break older client code do.
export const APP_SCHEMA_VERSION = 1;
